import { render } from "./IconExams.vue?vue&type=template&id=59ec1b27"
import script from "./IconExams.vue?vue&type=script&lang=js"
export * from "./IconExams.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__